import React from 'react';
import cn from 'classnames';

import { useReactionsCount, useTranslation, useAppSelector } from 'client/hooks';
import { selectBlockedUsersCount, selectSpokeUsersMetaData } from 'client/redux/pubnub/selectors';
import { thousandSeparator } from 'utils/thousand-separator';
import { USER_ROLES } from 'constants/index';

import Icon from '../Icon';

import css from './GeneralStatisticsList.module.scss';

interface Props {
  className?: string;
  totalListenersCount?: number;
  connectedListenersCount?: number;
  pendingRequestsCount?: number;
  userRole?: string;
}

const GeneralStatisticsList: React.FC<Props> = (props) => {
  const {
    className,
    totalListenersCount = 0,
    connectedListenersCount = 0,
    pendingRequestsCount = 0,
    userRole = '',
  } = props;
  const { translate } = useTranslation('actionsPanel');
  const { total: reactionsTotal } = useReactionsCount();
  const totalBlockedUsers = useAppSelector(selectBlockedUsersCount);
  const spokeUsersMetaData = useAppSelector(selectSpokeUsersMetaData);
  const isAdminOrHost = userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.HOST;

  return (
    <div className={cn(className, css.statisticList)}>
      <div className={css.item}>
        <div className={css.right}>
          <div className={css.iconWrapper}>
            <Icon type="participants_white" className={css.participantsIcon} />
          </div>

          {translate('usersStatisticsDrawer.totalUsers')}
        </div>
        <div className={css.left}>{thousandSeparator(totalListenersCount)}</div>
      </div>
      <div className={css.item}>
        <div className={css.right}>
          <div className={css.iconWrapper}>
            <Icon type="enter_white" className={css.enterIcon} />
          </div>
          {translate('usersStatisticsDrawer.connectedListeners')}
        </div>
        <div className={css.left}>{thousandSeparator(connectedListenersCount)}</div>
      </div>
      <div className={css.item}>
        <div className={css.right}>
          <div className={css.iconWrapper}>
            <Icon type="hand_white" className={css.requetsIcon} />
          </div>
          {translate('usersStatisticsDrawer.pendingRequests')}
        </div>
        <div className={css.left}>{thousandSeparator(pendingRequestsCount)}</div>
      </div>
      <div className={css.item}>
        <div className={css.right}>
          <div className={css.iconWrapper}>
            <Icon type="microphone_white" className={css.microphoneIcon} />
          </div>
          {translate('usersStatisticsDrawer.spokeListeners')}
        </div>
        <div className={css.left}>{thousandSeparator(spokeUsersMetaData.totalCount)}</div>
      </div>
      {isAdminOrHost && (
        <div className={css.item}>
          <div className={css.right}>
            <div className={css.iconWrapper}>
              <Icon type="black_forbid" className={css.blockedIcon} color={'white'} />
            </div>
            {translate('usersStatisticsDrawer.blocked')}
          </div>
          <div className={css.left}>{thousandSeparator(totalBlockedUsers)}</div>
        </div>
      )}
      <div className={css.item}>
        <div className={css.right}>
          <div className={css.iconWrapper}>
            <Icon type="like_white" className={css.likeIcon} />
          </div>
          {translate('usersStatisticsDrawer.reactions')}
        </div>
        <div className={css.left}>{thousandSeparator(reactionsTotal)}</div>
      </div>
    </div>
  );
};

export default GeneralStatisticsList;
